import { useCookies } from "react-cookie";
import styles from "./HelpText.module.css";

type Props = {
  children: string;
  alwaysVisible?: boolean;
};

export const HelpText = ({ children, alwaysVisible = false }: Props) => {
  const [cookie] = useCookies(["access_key", "disabled_information_messages"]);
  if (cookie.disabled_information_messages && !alwaysVisible) return <></>;
  return <div className={styles.container}>{children}</div>;
};
